import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bb_cart")) || []; } catch { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("bb_cart", JSON.stringify(items));
  }, [items]);

  const add = (buddy, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.slug === buddy.slug);
      if (existing) return prev.map((i) => i.slug === buddy.slug ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { slug: buddy.slug, name: `${buddy.name} the ${buddy.animal}`, price: buddy.price, image: buddy.image, color: buddy.color, qty }];
    });
    setDrawerOpen(true);
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const setQty = (slug, qty) => {
    if (qty < 1) return remove(slug);
    setItems((prev) => prev.map((i) => i.slug === slug ? { ...i, qty } : i));
  };
  const clear = () => setItems([]);

  const { subtotal, count } = useMemo(() => ({
    subtotal: items.reduce((s, i) => s + i.price * i.qty, 0),
    count: items.reduce((s, i) => s + i.qty, 0),
  }), [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count, drawerOpen, setDrawerOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
